// eslint-disable-next-line import/no-anonymous-default-export
export default {
  toolsTitle: 'HitPaw Онлайн Ultimate',
  freeTimesLimitTitle: 'Бесплатная пробная версия закончилась сегодня.',
  fileSizeLimitTitle:
    'Размер файла в бесплатной версии не может превышать 20 МБ.',
  freeImgCutoutTimesLimitTitle:
    'Сегодняшняя пробная версия для удаления фона исчерпана, пожалуйста, обновите до Pro, чтобы получить доступ ко всем премиум-функциям.',
  total: 'Все',
  enterCode: 'Ввести код',
  signUpToPurchaseBtn: 'Зарегистрироваться для покупки',
  goPurchseBtn: 'Перейти к покупке',
  saveTips: 'Сэкономить до {{num}}%',
  discount: 'Скидка',
  priceWeek: '$9,99',
  priceMonth: '$7,49',
  priceYear: '$3,75',
  billedMonth: '$29.99 Оплата ежемесячно',
  billedYear: '$179.99 Ежегодная оплата',
  monthly: 'Ежемесячный',
  yearly: 'Ежегодный',
  weekly: 'Еженедельно',
  week: 'неделю',
  AlreadySubscribe: 'Уже подписались?',
  vipTips1: 'Нет ограничений на размер файла',
  vipTips2: 'Нет ограничений на количество обрабатываемых файлов',
  vipTips3: 'Меняйте фон изображения без ограничений',
  vipTips4: 'Доступ ко всем бесплатным инструментам и премиум-функциям',
  purchaseTips:
    'Подписка будет автоматически продлена, и вы можете отменить ее в любое время.',
  tips: 'Примечание:',
  promoCodeInvalidTips: 'Ваш промокод недействителен',
  //2022.09.28 xxy
  freeImgBgChangerTimesLimitTitle:
    'Today’s trial oppotunity for changing background has been run out, please upgrade to Pro to access all premium features',
  vipBgChangerTips: 'Change image backgrounds without limits',
};
